import { NotaLiquidazioneVO } from "@vo/nota-liquidazioneVO";
import { CLONA_NOTA_ALLOWED_STATES } from "@app/constants";
import {UtenteVO} from "@vo/utenteVO";
import {StatoNotaEnum} from "@enum/stato-nota-enum";

export class NotaLiquidazioneHelper {
  static isCloneAllowed(nota: NotaLiquidazioneVO): boolean {
    if (nota == null || nota.stato == null) {
      return false;
    }
    return CLONA_NOTA_ALLOWED_STATES.indexOf(nota.stato) !== -1;
  }
  static isPrendiInCaricoAllowed(nota: NotaLiquidazioneVO, utente: UtenteVO): boolean {
    const result = utente && utente.isVerificatoreContabile &&
            nota && nota.presaInCarico === null &&
            nota.stato && [StatoNotaEnum.FIRMATO, StatoNotaEnum.APPROVATO, StatoNotaEnum.PAGATO].includes(nota.stato);
    console.log(result, {nota: nota, utente: utente});
    return result;
  }
  static getRiepilogoTotali(nota: NotaLiquidazioneVO): { importoLordo: number, ritenute: number, importoNetto: number } {
    let importoLordoTotale = 0;
    let ritenuteTotali = 0;

    if (nota && nota.anagraficheBeneficiarie) {
      for (const beneficiario of nota.anagraficheBeneficiarie) {
        const ritenutaPercentuale = beneficiario.ritenuta || 0;

        if (beneficiario.documentiSpesa) {
          for (const doc of beneficiario.documentiSpesa) {
            const importo = parseFloat(doc.importo || "0");
            const importoNetto = parseFloat(doc.importoNetto || "0");
            const nettoDaLiquidare = importoNetto > 0 ? importoNetto : importo;
            const ivaPercentuale = doc.iva || 0;
            const iva = ivaPercentuale > 0 ? (nettoDaLiquidare * ivaPercentuale) / 100 : 0;

            if (ritenutaPercentuale > 0) {
              ritenuteTotali += (nettoDaLiquidare * ritenutaPercentuale) / 100;
            }

            importoLordoTotale += nettoDaLiquidare + iva;
          }
        }
      }
    }

    return {
      importoLordo: importoLordoTotale,
      ritenute: ritenuteTotali,
      importoNetto: importoLordoTotale - ritenuteTotali
    };
  }
}
